function create<T1, T2>(f: Function, context?: T1) {
  return async function (runContext?: T2) {
    await f(context, runContext);
  };
}

export {create as createFun};
